module.exports = __webpack_public_path__ + "16d12923761298c0a0bb9ffea5cf633a.png";